export const actions = {
  set: 'SET::SELECTEDGRADE'
}

export const setSelectedGrade = gradeNumber => ({ type: actions.set, selectedGrade: gradeNumber })
export const getSelectedGrade = state => state.selectedGrade

export default actions